var _module_exports = "<div class=\"aside-wrap\"><div class=\"navi-wrap\"><nav ui-nav class=\"navi clearfix\" ng-include=\"'/app/common/partials/nav.html'\"></nav></div></div>\n";;
var path = '/app/vendor/ec-fe-bo-template/dist/views/partials/aside.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/vendor/ec-fe-bo-template/dist/views/partials/aside.html
// module id = 916
// module chunks = 0